import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * A group of adjacent nav items (e.g. main nav vs. help/settings).
 *
 * `label` renders the design's muted group heading above the items (the
 * settings nav's "Personal" / "Organization"); already translated, omit it
 * for an unlabeled group.
 */
@Component({
  selector: 'vx-sidebar-nav-group',
  templateUrl: './sidebar-nav-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-0.5' },
})
export class VxSidebarNavGroupComponent {
  readonly label = input<string>();
}
